import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-copy-button',
	templateUrl:'./WaCopyButtonPage.html',
	styles: [],
	styleUrls:['./WaCopyButtonPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaCopyButtonPage
{
	mdContent_320 = `\`\`\`java
import com.jwebmp.webawesome.components.copybutton.WaCopyButton;
\`\`\``;
	mdContent_321 = `\`\`\`java
var btn = new WaCopyButton<>();
btn.setValue("npm install angular-awesome");
\`\`\``;
}
